import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  defaultLeaseColumnMappings,
  defaultSaleColumnMappings
} from 'helpers/comps/comp_info_mappings';

import TableHeader from 'components/table_header/table_header';
import CompsColumnSelector from './columns/selector';
import { getCurrentColumns } from './store/selectors/session';
import { hideOverlayFilters, showOverlayFilters } from './store/actions/ui';
import { columnTypes, excludedColumns } from 'helpers/comps/global_table_constants';
import { getCurrentColumnProps } from './columns/helpers';

export class CompsTableHeader extends React.Component {
  static propTypes = {
    compType: PropTypes.string.isRequired,
    currentColumns: PropTypes.array.isRequired,
    currentTab: PropTypes.string.isRequired,
    customFieldSchemas: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
    })).isRequired,
    edgeCrm: PropTypes.bool,
    hideOverlayFilters: PropTypes.func.isRequired,
    setColumns: PropTypes.func.isRequired,
    showColumnFilters: PropTypes.bool,
    showOverlayFilters: PropTypes.func.isRequired,
    sort: PropTypes.string,
    onSortChange: PropTypes.func.isRequired
  };

  render() {
    const { compType, currentColumns, currentTab, customFieldSchemas, edgeCrm } = this.props;
    const currentColumnProps = getCurrentColumnProps(currentColumns, edgeCrm, customFieldSchemas, currentTab);
    const unsortableColumnKeys = [...excludedColumns, ...customFieldSchemas.map(schema => schema.slug)];

    return (
      <TableHeader
        {...this.props}
        {...currentColumnProps}
        defaultColumnMappings={compType === 'lease' ? defaultLeaseColumnMappings : defaultSaleColumnMappings}
        excludedColumns={unsortableColumnKeys}
        sortableColumnTypes={columnTypes}
      >
        {!edgeCrm && <CompsColumnSelector/>}
      </TableHeader>
    );
  }
}

const mapStateToProps = state => ({
  currentColumns: getCurrentColumns(state),
  currentTab: state.ui.currentTab,
  customFieldSchemas: state.customFieldSchemas,
  edgeCrm: state.features.edgeCrm,
  showColumnFilters: state.ui.showColumnFilters
});

const mapDispatchToProps = {
  hideOverlayFilters,
  showOverlayFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsTableHeader);
